<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num=0" :class="{active: num == 0}"><common-data name="appShortName_38"/>介绍 </li>
            <li @click="num=1" :class="{active: num == 1}">功能介绍</li>
            <li @click="num=2" :class="{active: num == 2}">购买须知</li>
            <!-- <li @click="num=3" :class="{active: num == 3}">服务介绍</li> -->
        </ul>
        <div class="details_gn" v-show="num == 0">
            <p class="intent">
                <common-data name="appShortName_38"/><common-data name="appFullName_38"/>是文华财经旗下的一款期货行情分析软件，面向信创体系内的期货经营机构、金融机构、专业投资团队等，提供期货相关的全市场实时行情及历史数据，以及专业、丰富的分析工具与可视化图表。
            </p>
            <p class="intent">
                适配统信UOS操作系统、银河麒麟操作系统的运行环境要求，在稳定性、兼容性及安全性上完全符合信创生态标准，为政务、金融等信创重点领域的期货行情分析提供高效、可靠的工具支撑。
            </p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 1">
            <p class="detail_title">3C套餐</p>
            <p>涵盖行情展示、技术分析图表、24小时资讯等行情功能，以及特色功能文华商品指数、产业分析图表、期权分析图表、预警工具...</p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 2">
            <p class="tent">1.付费成功后如无功能问题恕不退不换。</p>
            <p class="tent">2.购买前请先下载<a href="https://wh3.wenhua.com.cn/" target="_blank"><common-data name="appShortName_38"/></a>体验版了解软件基础功能。</p>
            <p class="tent">
                3.使用<common-data name="appShortName_38"/>软件的电脑配置要求：<br />
                · X86架构和ARM架构的4核CPU/8G内存（RAM），或更高配置；<br />
                · 统信UOS、银河麒麟64位操作系统；
            </p>
            <p class="tent">4.推荐南方地区使用电信网络，北方地区使用联通网络，其它网络使用效果不佳。</p>
        
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
        <div class="details_gn" v-show="num == 3">

            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 2
            }
        },
        mounted () {
            
        }
    }
</script>
<style scoped>
@import url('./doc.css');
.details_gn {
    min-height: 255px;
}
</style>